import ReinforcementLearningRewardsEndpointRequest from '../schema/ReinforcementLearningRewardsEndpointRequest';
import { getAccessTokenforResourceAsLazy } from 'owa-tokenprovider';

/**
 * Makes the Reinforcement Learning Rewards Endpoint request
 */
export default function reinforcementLearningRewardsEndpointService(
    request: ReinforcementLearningRewardsEndpointRequest,
    scenarioId: string,
    userId: string,
    tenantId: string
): Promise<any> {
    const url: string = `https://onlineaippe.westus2.cloudapp.azure.com:9001/SubstrateRL/api/reward/scenario(${encodeURIComponent(
        scenarioId
    )})/user(${encodeURIComponent(userId)}@${encodeURIComponent(tenantId)})`;

    let fetchPromise: Promise<any>;

    getAccessToken().then(accessToken => {
        const headers = new Headers({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
        });

        let requestInit: RequestInit = {
            method: 'POST',
            body: JSON.stringify(request),
            headers: headers,
        };

        fetchPromise = fetch(url, requestInit).catch(error => Promise.resolve());
    });

    return fetchPromise;
}

async function getAccessToken(): Promise<string> {
    let [token, tokenPromise] = getAccessTokenforResourceAsLazy(window.location.origin);

    if (!token) {
        token = (await tokenPromise) as string;
    }

    return token as string;
}
